import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import 'bootstrap4-duallistbox'
import 'bootstrap4-duallistbox/dist/bootstrap-duallistbox.css'
import AjaxHandler from '../../commons/ajax/AjaxHandler.js'
import Loading from '../ui/Loading.js'
import 'react-select/dist/react-select.css'
import 'moment/min/locales'
import {FormattedMessage, injectIntl} from 'react-intl';
import backendStrings from '../../lang/backendStrings.js';
import DatePicker from 'react-datepicker'
import moment from 'moment'
import 'react-dropzone-component/styles/filepicker.css'
import 'react-datepicker/dist/react-datepicker.css'
import 'dropzone/dist/min/dropzone.min.css'


class ConfigPeriodosPresupuestariosAbm extends Component {
	constructor(props) {
		super(props);
		this.ajaxHandler = new AjaxHandler();
		
		this.state = {
			redirectTo: null,
			props: this.props,
			formData: {
				id: 0,
				nombre: '',
                frecuencia: '',
                duracion: '',
                fecha_inicio: null,
			},
			errors: [],
			loading: false
		};
		
		this.handleInputFormChange = this.handleInputFormChange.bind(this);
		
		this.handleSubmit = this.handleSubmit.bind(this);

  	}


  	componentWillUnmount() {
		this.ajaxHandler.unsubscribe();
	}

	componentWillMount() {
			this.ajaxHandler.subscribe(this);
			this.initForm();
  	}

  	initForm() {
		this.setState({ loading: true });
		let component = this;
		
		Promise.all([
			this.state.props.action !== 'ADD' ? this.ajaxHandler.getJson('/periodo-configs/' + this.state.props.match.params.id) : null,
		]).then((data) => {
			let formData = data[0].periodos;
			if(formData) component.setState({
				formData: formData[0]
			});

		}).catch(function(error) {
			
		}).finally(() => {
			this.setState({ loading: false });
		});
	
	}
 
	handleInputFormChange(event) {
		const target = event.target;
		const name = target.name;
		const value = target.type === 'checkbox' ? target.checked : target.value;

		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy[name] = value;
		this.setState({
			formData: formDataCopy
		});

  	}

	  handleDatePickerFormChange(name, event) {
        let date = event ? event.format(): null;
        let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
        formDataCopy[name] = date;
        this.setState({
            formData: formDataCopy
        });
    }

	handleDatePickerFormRawChange(name, date) {
        let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
        formDataCopy[name] = date === '' ? null : date;
        this.setState({
            formData: formDataCopy
        });
    }

	handleSubmit(event) {

		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));

        this.setState({
            formData: formDataCopy,
            loading: true
        }, () => {
            let component = this;
            this.ajaxHandler.fetch('/periodo-configs' + (this.props.action === 'ADD' ? '' : '/' + this.state.formData.id), {
                method: this.props.action === 'ADD' ? 'POST' : 'PUT',
                body: JSON.stringify({
                    ...this.state.formData
                }),
            }).then(response => {
                if(response.status !== 400) {
                    component.exit();
                } else {
                    response.json()
                        .then(data => {
                            this.setState({
                                errors: data.detalle
                            });
                        });
                }
                window.scrollTo(0,0);
            }).catch((error) => {
                this.ajaxHandler.handleError(error);
            }).finally(() => {
                this.setState({ loading: false });
            });
        });

        event.preventDefault();

	}


	handleCancel(event) {
		this.exit();
	}

	exit() {
		this.setState({
			redirectTo: '/configPeriodosPresupuestarios'
		});
	}

	render() {
		let formData = this.state.formData;
		let state = this.state;
		return (
			<React.Fragment>
				{this.state.redirectTo && <Redirect push to={this.state.redirectTo} />}
				{this.state.loading && <Loading />}				
				<div className="row">
					<div className="col-md-12">
						<div className="alert alert-danger" role="alert" hidden={this.state.errors.length===0}>
							{this.state.errors.map((e, i) => <li key={i}><FormattedMessage {...(backendStrings[e] ? backendStrings[e] : backendStrings['errors.default'])}/></li>)}
						</div>
						<form className="form form-horizontal" ref="form" onSubmit={this.handleSubmit}>
							<div className="form-body">
								<div className="card pull-up">
									<div className="card-content">
										<div className="card-body">      
											<h4 className="form-section">
												<i className="icon-home"></i><FormattedMessage id="tareasAbm.render.general_data.header_datos_generales" defaultMessage=" Datos Generales "/><div className="float-right" style={{fontSize:'14px'}}>* <FormattedMessage id="tareasAbm.render.general_data.campos_requeridos" defaultMessage="campos requeridos"/></div>
											</h4>
											<div className="row">
												{/* Nombre del ciclo */}
												<div className="col-md-6">
													<div className="form-group row">
														<label className="col-md-3 label-control col-form-label" htmlFor="nombre">
															<FormattedMessage id="nombre" defaultMessage="Nombre del ciclo"/>*:
														</label>
														<div className="col-md-9">
															{this.props.action === 'VIEW' ? (
																<div className="form-control-static col-form-label form-value">{formData.nombre}</div>
															) : (
																<div>
																	<input type="text" className="form-control" id="nombre" name="nombre" placeholder={this.props.intl.formatMessage({ id: 'nombre', defaultMessage: 'nombre' })} value={formData.nombre} onChange={this.handleInputFormChange} /> 
																</div>
															)}															
														</div>
													</div>
												</div>
											</div>
                                            <div className="row">
												{/* Frecuencia */}
												<div className="col-md-6">
													<div className="form-group row">
														<label className="col-md-3 label-control col-form-label" htmlFor="frecuencia">
															<FormattedMessage id="frecuencia" defaultMessage="Frecuencia"/>*:
														</label>
														<div className="col-md-9">
															{this.props.action === 'VIEW' ? (
																<div className="form-control-static col-form-label form-value">{formData.frecuencia}</div>
															) : (
																<div>
																	<select
																		className="form-control"
																		id="frecuencia"
																		name="frecuencia"
																		value={formData.frecuencia}
																		onChange={this.handleInputFormChange}
																	>
																		<option value="" disabled selected>Seleccionar</option>
																		<option value="mensual">Mensual</option>
																		<option value="bimestral">Bimestral</option>
																		<option value="trimestral">Trimestral</option>
																		<option value="cuatrimestral">Cuatrimestral</option>
																		<option value="semestral">Semestral</option>
																		<option value="anual">Anual</option>
																	</select>
																</div>
															)}															
														</div>
													</div>
												</div>
											</div>
											<div className="row">
												{/* Duración del ciclo */}
												<div className="col-md-6">
													<div className="form-group row">
														<label className="col-md-3 label-control col-form-label" htmlFor="duracion">
															<FormattedMessage id="duracion" defaultMessage="Duración del ciclo"/>*:
														</label>
														<div className="col-md-9">
															{this.props.action === 'VIEW' ? (
																<div className="form-control-static col-form-label form-value">{formData.duracion === "1" ? formData.duracion + " Año" : formData.duracion + " Años"}</div>
															) : (
																<div>
																	<select
																		className="form-control"
																		id="duracion"
																		name="duracion"
																		value={formData.duracion}
																		onChange={this.handleInputFormChange}
																	>
																		<option value="" disabled selected>Seleccionar</option>
																		<option value="1">1 Año</option>
																		<option value="2">2 Años</option>
																		<option value="3">3 Años</option>
																		<option value="4">4 Años</option>
																		<option value="5">5 Años</option>
																	</select>
																</div>
															)}															
														</div>
													</div>
												</div>
											</div>
											<div className="row">
												{/* Fecha Inicio */}
												<div className="col-md-6">
													<div className="form-group row">
														<label className="col-md-3 label-control col-form-label" htmlFor="fecha_inicio">
															<FormattedMessage id="fecha_inicio" defaultMessage="Fecha de inicio del primer período"/>*:
														</label>
														<div className="col-md-9">
															{this.props.action === 'VIEW' ? (
																<div className="form-control-static col-form-label form-value">{formData.fecha_inicio}</div>
															) : (
																<div>
																<DatePicker
																  id="fecha_inicio"
																  name="fecha_inicio"
																  className="form-control date-picker-placeholder"
																  placeholderText={this.props.intl.formatMessage({ id: 'configPeriodosPresupuestariosAbm.render.general_data.placeholder_fecha_inicio', defaultMessage: 'DD/MM/AAAA' })}
																  selected={formData.fecha_inicio === null || formData.fecha_inicio === '0000-00-00' ? null : moment(formData.fecha_inicio) }
																  onChange={(event) => this.handleDatePickerFormChange("fecha_inicio", event)}
																  onChangeRaw={(event) => this.handleDatePickerFormRawChange("fecha_inicio", event.target.value)}
																  openToDate={moment()}
																  showMonthDropdown
																  showYearDropdown
																  dropdownMode="select"
																/>																
															  </div>
															)}															
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="card pull-up">
									<div className="card-content">
										<div className="card-body">     
											<div className="text-cd text-right">
												{this.props.action !== 'VIEW' && (
													<button type="submit" className="btn btn-primary mr-1" >
														<i className="fa fa-check-circle"></i><FormattedMessage id="tareasAbm.finish_button.guardar" defaultMessage=" Guardar"/>
													</button>
												)}
												<button type="button" className="btn btn-danger" onClick={this.handleCancel.bind(this)}>
													<i className="fa fa-times-circle"></i> {this.props.action === 'VIEW' ? this.props.intl.formatMessage({ id: 'tareasAbm.finish_button.volver', defaultMessage: 'Volver' }) : this.props.intl.formatMessage({ id: 'tareasAbm.finish_button.cancelar', defaultMessage: 'Cancelar' })}
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</form>
					</div>
				</div>
			</React.Fragment>
		);
	}
}

export default injectIntl(ConfigPeriodosPresupuestariosAbm);